/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Enable({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M7.314 5.327H3.83a2.673 2.673 0 1 0 0 5.346h3.483a4.756 4.756 0 0 1-.587-1.2H3.831a1.473 1.473 0 0 1 0-2.946h2.896c.14-.43.338-.833.587-1.2Z" /><path fill="currentColor" fillRule="evenodd" d="M11.269 11.573a3.573 3.573 0 1 0 0-7.146 3.573 3.573 0 0 0 0 7.146Zm2.098-4.472a.6.6 0 1 0-.925-.764l-1.679 2.031-.71-.774a.6.6 0 1 0-.885.812l1.177 1.281a.6.6 0 0 0 .904-.023L13.367 7.1Z" clipRule="evenodd" /></svg>;
}
;